var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "f7-popup",
    {
      staticClass: "switchProfilePopup",
      attrs: { id: _vm.nameId, opened: _vm.popupOpened },
      on: {
        "popup:opened": function ($event) {
          _vm.popupOpened = true
        },
        "popup:closed": function ($event) {
          _vm.popupOpened = false
        },
      },
    },
    [
      _c("div", { staticClass: "switchProfileBack" }, [
        _c(
          "div",
          { staticClass: "switchProfileContent" },
          [
            _c("div", { staticClass: "switchProfileTitleBox" }, [
              _c("a", { staticClass: "switchProfileTitle" }, [
                _vm._v(_vm._s(_vm.$t("leftPanelTitle.swtch_prfl"))),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "f7-list",
              { staticClass: "switchProfileList", attrs: { "media-list": "" } },
              _vm._l(_vm.accounts, function (accountItem, index) {
                return _c("f7-list-item", {
                  key: "profile-" + index,
                  staticClass: "boxRequest",
                  class: { disabled: false },
                  attrs: {
                    media:
                      "<div class='manualChip'>" +
                      accountItem.name[0].toUpperCase() +
                      "</div>",
                    title: accountItem.name,
                    subtitle: accountItem.identifier,
                    badge: _vm.selected(accountItem.id),
                    text: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.switchAccount(accountItem.id)
                    },
                  },
                })
              }),
              1
            ),
            _vm._v(" "),
            _c("f7-link", { staticClass: "cancelContainer" }, [
              _c(
                "div",
                { staticClass: "cancelBox" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary", size: "lg" },
                      on: {
                        click: function ($event) {
                          _vm.popupOpened = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("common.bck")) +
                          "\n          "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }